import React from 'react'
import { StockList } from './stock_list'
import { FavorListHead } from './favor_list_head'
import { store } from '../../../../store/favor/store'
import { Observer } from 'mobx-react-lite'
import { DelayQuoteTips } from './delay_quote_tips'
import { LoadStatus } from '../../../shared/load_status'

export function FavorList() {

  return (
    <Observer>
      {() => (
        <div>
          <DelayQuoteTips hk_cn={store.delayTips.hk_cn} hk_overseas={store.delayTips.hk_overseas} />
          <dl className={`comm-stock-list ${store.stockScroll}`}>
            <FavorListHead />
            {store.stockCodes.length ? <StockList /> : <LoadStatus icon={false} title={'暂无该自选股票'} className={'com_tips'} />}
          </dl>
        </div>
      )}
    </Observer>
  )
}
